import appConstants from '@/constants/constants'
import Vue from 'vue'
import { sortGroupsByPositions } from '@/composables/serviceGroupHelper'
import { sortServicesByPositions } from '@/composables/serviceHelper'
import { cloneDeep } from 'lodash'
import { initialAbility } from '@/libs/acl/config'

export default {
  // Nds type
  SET_NDS_TYPE (state, nds) {
    state.nds = nds
  },
  EDIT_NDS_TYPE (state, nds) {
    const index = state.nds.findIndex(u => u.id === nds.id)
    state.nds[index].value = nds.value
  },
  ADD_NDS_TYPE (state, nds) {
    state.nds.push(nds)
  },
  // Units type
  SET_UNITS_TYPE (state, units) {
    state.units = units
  },
  EDIT_UNIT_TYPE (state, unit) {
    const index = state.units.findIndex(u => u.id === unit.id)
    state.units[index].short_name = unit.short_name
    state.units[index].full_name = unit.full_name
  },
  ADD_UNIT_TYPE (state, unit) {
    state.units.push(unit)
  },
  REMOVE_UNIT_TYPE (state, unitId) {
    const index = state.units.findIndex(unit => unit.id === unitId)
    state.units.splice(index, 1)
  },
  // Discount Cards
  SET_DISCOUNTS_CARDS (state, cards) {
    state.discountCardsList = cards
  },
  EDIT_DISCOUNTS_CARDS (state, card) {
    const index = state.discountCardsList.findIndex(c => c.id === card.id)
    state.discountCardsList[index].name = card.name
    state.discountCardsList[index].percent = card.percent
  },
  ADD_DISCOUNT_CARD (state, card) {
    state.discountCardsList.push(card)
  },
  REMOVE_DISCOUNT_CARD (state, cardId) {
    const index = state.discountCardsList.findIndex(card => card.id === cardId)
    state.discountCardsList.splice(index, 1)
  },
  // Payment Method
  SET_PAYMENT_METHODS: (state, items) => state.paymentMethods = items,
  EDIT_PAYMENT_METHOD(state, method) {
    const index = state.paymentMethods.findIndex(m => m.id === method.id)
    state.paymentMethods[index].name = method.name
    state.paymentMethods[index].extended_category = method.extended_category
  },
  ADD_PAYMENT_METHOD (state, method) {
    state.paymentMethods.push(method)
  },
  REMOVE_PAYMENT_METHOD (state, methodId) {
    const index = state.paymentMethods.findIndex(method => method.id === methodId)
    state.paymentMethods.splice(index, 1)
  },
  SET_PAYMENT_METHOD_EXTENDED_CATEGORIES (state, categories) {
    state.paymentMethodExtendedCategories = categories
  },
  // Payment Direction
  SET_PAYMENT_DIRECTION (state, directions) {
    state.paymentDirections = directions
  },
  SET_PAYMENT_DIRECTION_TYPES (state, directionTypes) {
    state.paymentDirectionTypes = directionTypes
  },
  REMOVE_PAYMENT_DIRECTION (state, paymentDirectionId) {
    const index = state.paymentDirections.findIndex(paymentDirection => paymentDirection.id === paymentDirectionId)
    state.paymentDirections.splice(index, 1)
  },
  EDIT_PAYMENT_DIRECTION (state, paymentDirection) {
    const index = state.paymentDirections.findIndex(pd => pd.id === paymentDirection.id)
    state.paymentDirections[index].name = paymentDirection.name
    state.paymentDirections[index].type = paymentDirection.type
  },
  ADD_PAYMENT_DIRECTION (state, paymentDirection) {
    state.paymentDirections.push(paymentDirection)
  },
  // Contacts
  SET_CONTACTS (state, contacts) {
    state.contacts = contacts
  },
  EDIT_CONTACT (state, contact) {
    const index = state.contacts.findIndex(c => c.id === contact.id)
    state.contacts[index].name = contact.name
  },
  ADD_CONTACT (state, contact) {
    state.contacts.push(contact)
  },
  REMOVE_CONTACT (state, contactId) {
    const index = state.contacts.findIndex(contact => contact.id === contactId)
    state.contacts.splice(index, 1)
  },
  // Employee
  SET_EMPLOYEE: (state, items) => state.employee = items,
  SET_EMPLOYEE_BY_CLINIC_PER_PAGE: (state, items) => state.employeeByClinicPerPage = items,
  SET_EMPLOYEE_BY_CLINIC_PER_PAGE_COUNT: (state, count) => state.employeeByClinicPerPageCount = count,
  // Role
  SET_ROLES (state, roles) {
    state.roles = roles
  },
  EDIT_ROLE (state, role) {
    const index = state.roles.findIndex(e => e.id === role.id)
    state.roles[index].name = role.name
  },
  ADD_ROLE (state, role) {
    state.roles.push(role)
  },
  REMOVE_ROLE (state, roleId) {
    const index = state.roles.findIndex(role => role.id === roleId)
    state.roles.splice(index, 1)
  },
  // Permissions
  SET_PERMISSIONS (state, permissions) {
    state.permissions = permissions
  },
  SET_PERMISSIONS_FOR_USER (state, permissions) {
    state.user_permissions = permissions
  },
  EMPTY_ABILITIES: state => state.abilities = [],
  SET_ROOT_ABILITIES: state => state.abilities = [{ action: 'manage', subject: 'all' }],
  SET_ABILITIES(state, permissions) {
    const abilityByEntity = {}
    permissions.forEach(permission => {
      const splitPermission = permission.split('_')
      if (!abilityByEntity.hasOwnProperty(splitPermission[1])) {
        abilityByEntity[splitPermission[1]] = []
      }
      let action = ''
      switch (splitPermission[0]) {
        case 'add':
          action = 'create'
          break
        case 'delete':
          action = 'delete'
          break
        case 'change':
          action = 'update'
          break
        case 'view':
          action = 'read'
          break
      }
      abilityByEntity[splitPermission[1]].push(action)
    })
    state.abilities.push(initialAbility[0])
    Object.keys(abilityByEntity).forEach(entity => {
      abilityByEntity[entity].forEach(action => {
        state.abilities.push({
          action: action,
          subject: entity
        })
      })
    })
  },
  // Materials
  SET_MATERIAL_GROUPS (state, groups) {
    state.materialGroups = groups.map(g => {
      g.expanded = false
      g.materials = []
      return g
    })
  },
  SET_DETAILED_MATERIALS_GROUPS(state, data) {
    state.detailedMaterialsGroupsInfo = data
    if (data.items && data.items.length) {
      state.materialGroups = data.items.map(g => {
        g.expanded = false
        g.materials = []
        return g
      })
    }
  },
  SET_MATERIALS_BY_GROUP(state, data) {
    const index = state.materialGroups.findIndex(g => g.id === data.groupId)
    state.materialGroups[index].expanded = true
    state.materialGroups[index].materials = data.list.results
    state.materialGroups[index].count = data.list.count
  },
  SET_MATERIALS_PER_PAGE: (state, items) => state.materialsPerPage = items,
  SET_MATERIALS_PER_PAGE_COUNT: (state, count) => state.materialsPerPageCount = count,
  material_group_added (state, group) {
    group.expanded = false
    group.materials = []
    state.materialGroups.push(group)
  },
  material_group_edited (state, group) {
    const index = state.materialGroups.findIndex(g => g.id === group.id)
    state.materialGroups[index].name = group.name
  },
  MATERIAL_GROUP_DELETED(state, group) {
    const index = state.materialGroups.findIndex(g => g.id === group.id)
    state.materialGroups.splice(index, 1)
  },
  material_edited (state, material) {
    const indexGroup = state.materialGroups.findIndex(g => g.id === material.material_group_id)
    const indexMaterial = state.materialGroups[indexGroup].materials.findIndex(m => material.id)
    if (indexMaterial) {
      state.materialGroups[indexGroup].materials[indexMaterial] = material
    } else {
      state.materialGroups[indexGroup].materials.push(material)
    }
  },
  MATERIAL_DELETED(state, material) {
    const indexGroup = state.materialGroups.findIndex(g => g.id === material.material_group_id)
    const indexMaterial = state.materialGroups[indexGroup].materials.findIndex(m => m.id === material.id)
    state.materialGroups[indexGroup].materials.splice(indexMaterial, 1)
    state.materialGroups = cloneDeep(state.materialGroups)
  },
  MATERIAL_GROUP_HIDDEN(state, group) {
    const indexGroup = state.materialGroups.findIndex(g => g.id === group.id)
    state.materialGroups[indexGroup].expanded = false
    state.materialGroups = cloneDeep(state.materialGroups)
  },
  MATERIAL_LOT_ADDED(state, item) {
    state.materialLotsPerPage.push(item)
    state.materialLotsPerPageCount += 1
  },
  MATERIAL_LOT_EDITED(state, item) {
    const index = state.materialLotsPerPage.findIndex(element => element.id === item.id)
    Vue.set(state.materialLotsPerPage, index, item)
  },
  SET_MATERIAL_LOTS(state, items) {
    state.materialLotsPerPage = items
  },
  SET_MATERIAL_LOTS_COUNT(state, count) {
    state.materialLotsPerPageCount = count
  },
  MATERIAL_LOT_DELETED(state, item) {
    const index = state.materialLotsPerPage.findIndex(lot => lot.id === item.id)
    state.materialLotsPerPage.splice(index, 1)
    state.materialLotsPerPageCount -= 1
  },
  MATERIAL_LOT_MOVED(state, data) {
    const index = state.materialLotsPerPage.findIndex(
      lot => lot.id === data.lotId && lot.material.id !== data.materialId
    )
    if (index > -1) {
      state.materialLotsPerPage.splice(index, 1)
      state.materialLotsPerPageCount -= 1
    }
  },
  RESTART_MATERIAL_LOT(state, data) {
    const idx = state.materialLotsPerPage.findIndex(item => item.id === data.id)
    state.materialLotsPerPage[idx].posted = true
    state.materialLotsPerPage[idx].expend_finished = false
    state.materialLotsPerPage[idx].remainder = data.remainder
    state.materialLotsPerPage[idx].number_of_material = data.number_of_material
  },
  MATERIAL_LOT_CANCEL_PLACEMENT(state, data) {
    const idx = state.materialLotsPerPage.findIndex(item => item.id === data.id)
    state.materialLotsPerPage[idx].posted = false
  },
  MATERIAL_LOT_PLACE(state, data) {
    const idx = state.materialLotsPerPage.findIndex(item => item.id === data.id)
    state.materialLotsPerPage[idx].posted = true
  },
  SET_LOT_WITH_MATERIAL_ITEMS(state, items) {
    state.lotWithMaterialItems = items
  },
  SET_LOT_WITH_MATERIAL_ITEMS_COUNT(state, count) {
    state.lotWithMaterialItemsCount = count
  },
  SET_SERVICES_RECALCULATION_PROCESS_ACTIVE_STATUS: (state, val) => state.servicesRecalculationProcessIsActive = val,
  // Diagnosis
  SET_DIAGNOSIS_GROUPS (state, groups) {
    state.diagnosisGroupsList = groups
  },
  DIAGNOSIS_DELETE(state, diagnosisId) {
    const index = state.diagnosis.findIndex(d => d.id === diagnosisId)
    state.diagnosis.splice(index, 1)
  },
  SET_DIAGNOSIS_GROUPS_MAIN (state, groups) {
    state.diagnosisGroupsMain = groups.map(g => {
      g.children = []
      return g
    })
  },
  SET_DIAGNOSIS_SUB_GROUPS (state, groups) {
    state.diagnosisSubGroups = groups
  },
  SET_DIAGNOSIS_GROUPS_ALL (state, groups) {
    state.diagnosisGroupsAll = groups
  },
  diagnosis_group_added (state, group) {
    if (group.parent_group_id === null) {
      state.diagnosisGroupsMain.push(group)
    } else {
      state.diagnosisSubGroups.push(group)
    }
  },
  diagnosis_group_edited (state, group) {
    const index = state.diagnosisGroupsMain.findIndex(g => g.id === group.id)
    if (
      index !== -1
      && state.diagnosisGroupsMain[index].parent_group_id === null
      && group.parent_group_id !== null
    ) {
      state.diagnosisGroupsMain.splice(index, 1)
    } else if (index !== -1) {
      state.diagnosisGroupsMain[index].name = group.name
      state.diagnosisGroupsMain[index].parent_group_id = group.parent_group_id
    } else if (index === -1 && group.parent_group_id === null) {
      state.diagnosisGroupsMain.push(group)
    }
  },
  DIAGNOSIS_GROUP_DELETED(state, group) {
    if (group.parent_group_id) {
      const index = state.diagnosisSubGroups.findIndex(g => g.id === group.id)
      state.diagnosisSubGroups.splice(index, 1)
    } else {
      const index = state.diagnosisGroupsMain.findIndex(g => g.id === group.id)
      state.diagnosisGroupsMain.splice(index, 1)
    }
  },
  SET_DIAGNOSIS (state, diagnosis) {
    state.diagnosis = diagnosis
  },
  SET_PATIENT_TEMPLATES_SEARCH (state, templates) {
    state.searchTemplates = templates
  },
  SET_PATIENT_TEMPLATES_SEARCH_TOTAL_COUNT (state, count) {
    state.searchTemplatesCount = count
  },
  set_diagnosis_total_count(state, count) {
    state.diagnosisCount = count
  },
  // Dental services
  SET_PATIENT_TEMPLATES_GROUPS_MAIN (state, groups) {
    state.patientCardTemplateMainGroups = groups.map(g => {
      g.children = []
      return g
    })
  },
  SET_PATIENT_TEMPLATES_GROUPS (state, groups) {
    state.patientCardTemplateGroups = groups
  },
  SET_SERVICES_GROUPS_MAIN(state, data) {
    state.servicesGroupsMain = sortGroupsByPositions(
      data.groups,
      `${appConstants.dentalServiceGroup.settings.POSITION_LOCAL_STORAGE_KEY}-${data.category}`
    )
  },
  SET_SERVICES_GROUPS(state, data) {
    state.servicesGroups = sortGroupsByPositions(
      data.groups,
      `${appConstants.dentalServiceGroup.settings.POSITION_LOCAL_STORAGE_KEY}-${data.category}-${data.id}`
    )
  },
  SET_MATERIAL_SERVICES_BY_MATERIAL_LOT: (state, items) => state.services = items.map(
    i => ({ selectable: i.price_info.prices_not_equal, canRecalculateService: i.price_info.prices_not_equal, ...i })
  ),
  SET_MATERIAL_SERVICES_BY_MATERIAL: (state, items) => state.services = items.map(i => ({ selectable: true, ...i })),
  SET_SERVICES(state, data) {
    state.services = data.category
      ? sortServicesByPositions(
          data.services,
        `${appConstants.dentalService.settings.POSITION_LOCAL_STORAGE_KEY}-${data.category}-${data.id}`
        )
      : data.services
  },
  SET_SERVICE_TYPES: (state, items) => state.serviceTypes = items,
  SET_DENTAL_SERVICES_WITH_TIME: (state, items) => state.dentalServicesWithTimePerPage = items,
  SET_DENTAL_SERVICES_WITH_TIME_TOTAL_COUNT: (state, count) => state.dentalServicesWithTimePerPageCount = count,
  SET_SERVICES_TOTAL_COUNT: (state, count) => state.servicesCount = count,
  SET_ALL_SERVICES_GROUPS: (state, services) => state.servicesGroupsAll = services,
  SERVICE_GROUP_ADDED(state, group) {
    if (group.parent_group_id) {
      state.servicesGroups.push(group)
    } else {
      state.servicesGroupsMain.push(group)
    }
  },
  ADD_PATIENT_TEMPLATE(state, group) {
    if (group.parent_group_id) {
      state.patientCardTemplateGroups.push(group)
    } else {
      state.patientCardTemplateMainGroups.push(group)
    }
  },
  EDIT_PATIENT_TEMPLATE(state, service) {
    const index = state.patientCardTemplateGroups.findIndex(s => s.id === service.id)
    if (index !== -1) {
      Object.keys(state.patientCardTemplateGroups[index]).forEach(key => {
        state.patientCardTemplateGroups[index][key] = service[key]
      })
    } else {
      state.patientCardTemplateGroups.push(service)
    }
  },
  TEMPLATE_PATIENT_DELETE(state, patientCardTemplateId) {
    const index = state.patientCardTemplateGroups.findIndex(tg => tg.id === patientCardTemplateId)
    state.patientCardTemplateGroups.splice(index, 1)
  },
  SERVICE_GROUP_EDITED(state, item) {
    const mainGroupsIndex = state.servicesGroupsMain.findIndex(g => g.id === item.id)
    if (mainGroupsIndex > -1) {
      if (item.parent_group_id) {
        if (!state.servicesGroupsMain[mainGroupsIndex].parent_group_id) {
          const childGroup = state.servicesGroups.find(g => g.id === item.parent_group_id)
          if (childGroup && childGroup.parent_group_id === item.id) {
            childGroup.parent_group_id = null
            state.servicesGroupsMain.push(childGroup)
          }
        }
        state.servicesGroupsMain.splice(mainGroupsIndex, 1)
      } else {
        state.servicesGroupsMain[mainGroupsIndex].name = item.name
        state.servicesGroupsMain[mainGroupsIndex].parent_group_id = item.parent_group_id
      }
    } else if (!item.parent_group_id) {
      state.servicesGroupsMain.push(item)
    }
  },
  SERVICE_ADDED(state, service) {
    state.services.push(service)
  },
  service_edited(state, service) {
    const index = state.services.findIndex(s => s.id === service.id)
    if (index !== -1) {
      Object.keys(state.services[index]).forEach(key => {
        state.services[index][key] = service[key]
      })
    } else {
      state.services.push(service)
    }
  },
  DENTAL_SERVICE_DELETE(state, dentalServiceId) {
    const index = state.services.findIndex(s => s.id === dentalServiceId)
    state.services.splice(index, 1)
  },
  SERVICE_GROUP_DELETED(state, group) {
    if (group.parent_group_id) {
      const index = state.servicesGroups.findIndex(g => g.id === group.id)
      state.servicesGroups.splice(index, 1)
    } else {
      const index = state.servicesGroupsMain.findIndex(g => g.id === group.id)
      state.servicesGroupsMain.splice(index, 1)
    }
  },
  // Bites
  SET_BITES (state, bites) {
    state.bitesList = bites
  },
  bite_added(state, bite) {
    state.bitesList.push(bite)
  },
  bite_edited(state, bite) {
    const index = state.bitesList.findIndex(b => b.id === bite.id)
    state.bitesList[index].name = bite.name
  },
  bite_removed(state, biteId) {
    const index = state.bitesList.findIndex(bite => bite.id === biteId)
    state.bitesList.splice(index, 1)
  },
  // Plans
  SET_PLANS: (state, plans) => state.plansList = plans,
  SET_PLANS_COUNT: (state, count) => state.plansCount = count,
  PLAN_REMOVED(state, planId) {
    const index = state.plansList.findIndex(plan => plan.id === planId)
    state.plansList.splice(index, 1)
  },
  SET_PLANS_WITH_TIME(state, items) {
    state.plansWithTimePerPage = items
  },
  SET_PLANS_WITH_TIME_TOTAL_COUNT(state, count) {
    state.plansWithTimePerPageCount = count
  },
  SET_INTEGRATORS_FOR_DROPDOWN: (state, items) => state.integratorsForDropdown = items,
  SET_INTEGRATORS: (state, items) => state.integrators = items,
  SET_INTEGRATORS_COUNT: (state, count) => state.integratorsCount = count,
  VIBER_CHAT_ENABLE(state, id) {
    const idx = state.integrators.findIndex(item => item.id === id)
    state.integrators[idx].viber_api_enabled = true
  },
  VIBER_CHAT_DISABLE(state, id) {
    const idx = state.integrators.findIndex(item => item.id === id)
    state.integrators[idx].viber_api_enabled = false
  },
  TELEGRAM_CHAT_ENABLE(state, id) {
    const idx = state.integrators.findIndex(item => item.id === id)
    state.integrators[idx].telegram_api_enabled = true
  },
  TELEGRAM_CHAT_DISABLE(state, id) {
    const idx = state.integrators.findIndex(item => item.id === id)
    state.integrators[idx].telegram_api_enabled = false
  },
  // Service time
  SET_SERVICE_TIMES: (state, items) => state.serviceTimes = items,
  SET_SERVICE_TIME_COUNT: (state, count) => state.serviceTimesCount = count,
  setPatientType(state, patientType) {
    state.patientType = patientType
  },
  setPatientTypes(state, patientType) {
    state.patientTypes = patientType
  },
  setPatientTypesCount(state, count) {
    state.patientTypesCount = count
  },
  SET_INTEGRATOR: (state, item) => state.integrator = item,
  setReserve(state, reserve) {
    state.reserve = reserve
  },
  emptyPatientType(state) {
    state.patientType = null
  },
  INTEGRATOR_ADDED(state, integrator) {
    state.integrators.push(integrator)
  },
  INTEGRATOR_EDITED(state, integrator) {
    const index = state.integrators.findIndex(element => element.id === integrator.id)
    Vue.set(state.integrators, index, integrator)
  },
  CHANGE_INTEGRATOR_SMS_NOTIFICATION_BALANCE(state, item) {
    const index = state.integrators.findIndex(element => element.id === item.id)
    state.integrators[index].sms_notification_balance = item.sms_notification_balance
  },
  patientTypeAdded(state, patientType) {
    state.patientTypes.push(patientType)
  },
  integratorDeleted(state, id) {
    state.integrators.splice(
      state.integrators.findIndex(item => id === item.id),
      1
    )
  },
  patientTypeEdited(state, patientType) {
    const index = state.patientTypes.findIndex(element => element.id === patientType.id)
    Vue.set(state.patientTypes, index, patientType)
  },
  PATIENT_TYPE_DELETE(state, id) {
    const index = state.patientTypes.findIndex(item => item.id === id)
    state.patientTypes.splice(index, 1)
  },
  setItems(state, config) {
    state[config.key] = config.data
  },
  itemUpdated(state, config) {
    const index = state[config.key].findIndex(element => element.id === config.data.id)
    Vue.set(state[config.key], index, config.data)
  },
  itemAdded(state, config) {
    state[config.key].push(config.data)
  },
  itemRemoved(state, config) {
    state[config.key].splice(
      state[config.key].findIndex(item => config.data.id === item.id),
      1
    )
  },
  emptyItem(state, config) {
    state[config.key] = null
  },
  setItem(state, config) {
    state[config.key] = config.data
  },
  // Advisory Opinion
  SET_ADVISORY_OPINION(state, advisoryOpinions) {
    state.advisoryOpinions = advisoryOpinions
  },
  EDIT_ADVISORY_OPINION(state, advisoryOpinion) {
    const index = state.advisoryOpinions.findIndex(item => item.id === advisoryOpinion.id)
    state.advisoryOpinions[index] = advisoryOpinion
  },
  ADD_ADVISORY_OPINION(state, advisoryOpinion) {
    state.advisoryOpinions.push(advisoryOpinion)
  },
  SET_ADVISORY_OPINION_COUNT(state, count) {
    state.advisoryOpinionsCount = count
  },
  ADVISORY_OPINION_DELETE(state, advisoryOpinionId) {
    const index = state.advisoryOpinions.findIndex(ad => ad.id === advisoryOpinionId)
    state.advisoryOpinions.splice(index, 1)
  },
  // INSURANCE COMPANIES
  INSURANCE_COMPANY_ADDED(state, insuranceCompany) {
    state.insuranceCompanies.push(insuranceCompany)
    state.insuranceCompaniesCount += 1
  },
  INSURANCE_COMPANY_EDITED(state, insuranceCompany) {
    const index = state.insuranceCompanies.findIndex(element => element.id === insuranceCompany.id)
    Vue.set(state.insuranceCompanies, index, insuranceCompany)
  },
  INSURANCE_COMPANY_DELETE(state, insuranceCompanyId) {
    const index = state.insuranceCompanies.findIndex(ad => ad.id === insuranceCompanyId)
    state.insuranceCompanies.splice(index, 1)
    state.insuranceCompaniesCount -= 1
  },
  SET_INSURANCE_COMPANIES_FOR_DROPDOWN: (state, items) => state.insuranceCompaniesForDropdown = items,
  SET_INSURANCE_COMPANIES: (state, items) => state.insuranceCompanies = items,
  SET_INSURANCE_COMPANIES_COUNT: (state, count) => state.insuranceCompaniesCount = count,
  // Notification condition category
  SET_NOTIFICATION_CONDITION_CATEGORIES_PER_PAGE(state, items) {
    state.notificationConditionCategoriesPerPage = items
  },
  SET_NOTIFICATION_CONDITION_CATEGORIES(state, items) {
    state.notificationConditionCategories = items
  },
  SET_NOTIFICATION_CONDITION_CATEGORIES_COUNT(state, count) {
    state.notificationConditionCategoriesTotalCount = count
  },
  NOTIFICATION_CONDITION_CATEGORY_ADD(state, item) {
    state.notificationConditionCategoriesPerPage.push(item)
    state.notificationConditionCategoriesTotalCount += 1
  },
  NOTIFICATION_CONDITION_CATEGORY_EDIT(state, item) {
    const index = state.notificationConditionCategoriesPerPage.findIndex(element => element.id === item.id)
    Vue.set(state.notificationConditionCategoriesPerPage, index, item)
  },
  NOTIFICATION_CONDITION_CATEGORY_DELETE(state, id) {
    const index = state.notificationConditionCategoriesPerPage.findIndex(ad => ad.id === id)
    state.notificationConditionCategoriesPerPage.splice(index, 1)
    state.notificationConditionCategoriesTotalCount -= 1
  },
  // Legal person
  SET_LEGAL_PERSONS(state, items) {
    state.legalPersons = items
  },
  SET_LEGAL_PERSONS_COUNT(state, count) {
    state.legalPersonsCount = count
  },
  LEGAL_PERSON_ADD(state, item) {
    state.legalPersons.push(item)
    state.legalPersonsCount += 1
  },
  LEGAL_PERSON_EDIT(state, item) {
    const index = state.legalPersons.findIndex(element => element.id === item.id)
    Vue.set(state.legalPersons, index, item)
  },
  LEGAL_PERSON_DELETE(state, id) {
    const index = state.legalPersons.findIndex(item => item.id === id)
    state.legalPersons.splice(index, 1)
    state.legalPersonsCount -= 1
  },
  // Contacts from
  SET_CONTACTS_FROM(state, items) {
    state.contactsFromList = items
  },
  // Patient appeal result
  SET_PATIENT_APPEAL_RESULTS(state, items) {
    state.patientAppealResults = items
  },
  SET_PATIENT_APPEAL_RESULTS_PER_PAGE(state, items) {
    state.patientAppealResultsPerPage = items
  },
  SET_PATIENT_APPEAL_RESULT_COUNT(state, count) {
    state.patientAppealResultsCount = count
  },
  PATIENT_APPEAL_RESULT_ADD(state, item) {
    state.patientAppealResultsPerPage.push(item)
    state.patientAppealResultsCount += 1
  },
  PATIENT_APPEAL_RESULT_EDIT(state, item) {
    const index = state.patientAppealResultsPerPage.findIndex(element => element.id === item.id)
    Vue.set(state.patientAppealResultsPerPage, index, item)
  },
  PATIENT_APPEAL_RESULT_DELETE(state, id) {
    const index = state.patientAppealResultsPerPage.findIndex(item => item.id === id)
    state.patientAppealResultsPerPage.splice(index, 1)
    state.patientAppealResultsCount -= 1
  },
  // Physician protocol fields
  PHYSICIAN_PROTOCOL_FIELDS_SET(state, items) {
    state.physicianProtocolFields = items
  },
  PHYSICIAN_PROTOCOL_FIELD_ADDED(state, item) {
    state.physicianProtocolFields.push(item)
    state.physicianProtocolFields = state.physicianProtocolFields.sort(
      (a, b) => a.name.toLowerCase() > b.name.toLowerCase()
        ? 1 : (b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 0)
    )
  },
  PHYSICIAN_PROTOCOL_FIELD_EDIT(state, item) {
    const index = state.physicianProtocolFields.findIndex(element => element.id === item.id)
    Vue.set(state.physicianProtocolFields, index, item)
  },
  PHYSICIAN_PROTOCOL_FIELD_DELETE(state, id) {
    const index = state.physicianProtocolFields.findIndex(item => item.id === id)
    state.physicianProtocolFields.splice(index, 1)
    state.physicianProtocolFieldValues = []
  },
  // Physician protocol field values
  PHYSICIAN_PROTOCOL_FIELD_VALUES_SET(state, items) {
    state.physicianProtocolFieldValues = items
  },
  PHYSICIAN_PROTOCOL_FIELD_VALUE_ADDED(state, item) {
    state.physicianProtocolFieldValues.push(item)
    state.physicianProtocolFieldValues = state.physicianProtocolFieldValues.sort(
      (a, b) => a.value.toLowerCase() > b.value.toLowerCase()
        ? 1 : (b.value.toLowerCase() > a.value.toLowerCase() ? -1 : 0)
    )
  },
  PHYSICIAN_PROTOCOL_FIELD_VALUE_EDIT(state, item) {
    const index = state.physicianProtocolFieldValues.findIndex(element => element.id === item.id)
    Vue.set(state.physicianProtocolFieldValues, index, item)
  },
  PHYSICIAN_PROTOCOL_FIELD_VALUE_DELETE(state, id) {
    const index = state.physicianProtocolFieldValues.findIndex(item => item.id === id)
    state.physicianProtocolFieldValues.splice(index, 1)
  },
  // Physician protocol section
  PHYSICIAN_PROTOCOL_SECTIONS_SET(state, items) {
    state.physicianProtocolSections = items
  },
  PHYSICIAN_PROTOCOL_SECTION_ADDED(state, item) {
    state.physicianProtocolSections.push(item)
    state.physicianProtocolSections = state.physicianProtocolSections.sort(
      (a, b) => a.name.toLowerCase() > b.name.toLowerCase()
        ? 1 : (b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 0)
    )
  },
  PHYSICIAN_PROTOCOL_SECTION_EDIT(state, item) {
    const index = state.physicianProtocolSections.findIndex(element => element.id === item.id)
    Vue.set(state.physicianProtocolSections, index, item)
  },
  PHYSICIAN_PROTOCOL_SECTION_DELETE(state, id) {
    const index = state.physicianProtocolSections.findIndex(item => item.id === id)
    state.physicianProtocolSections.splice(index, 1)
    state.physicianProtocolSubsections = []
  },
  // Physician protocol subsection
  PHYSICIAN_PROTOCOL_SUBSECTIONS_SET(state, items) {
    state.physicianProtocolSubsections = items
  },
  PHYSICIAN_PROTOCOL_SUBSECTION_ADDED(state, item) {
    state.physicianProtocolSubsections.push(item)
    state.physicianProtocolSubsections = state.physicianProtocolSubsections.sort(
      (a, b) => a.name.toLowerCase() > b.name.toLowerCase()
        ? 1 : (b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 0)
    )
  },
  PHYSICIAN_PROTOCOL_SUBSECTION_EDIT(state, item) {
    const index = state.physicianProtocolSubsections.findIndex(element => element.id === item.id)
    Vue.set(state.physicianProtocolSubsections, index, item)
  },
  PHYSICIAN_PROTOCOL_SUBSECTION_DELETE(state, id) {
    const index = state.physicianProtocolSubsections.findIndex(item => item.id === id)
    state.physicianProtocolSubsections.splice(index, 1)
  },
  // Physician protocol
  PHYSICIAN_PROTOCOLS_SET_PER_PAGE(state, items) {
    state.physicianProtocolPerPage = items
  },
  PHYSICIAN_PROTOCOLS_SET_PER_PAGE_COUNT(state, count) {
    state.physicianProtocolPerPageCount = count
  },
  PHYSICIAN_PROTOCOL_DELETE(state, id) {
    const index = state.physicianProtocolPerPage.findIndex(item => item.subsection_id === id)
    state.physicianProtocolPerPage.splice(index, 1)
  },
  // Analyses Synevo
  ANALYSES_SYNEVO_SET_PER_PAGE(state, items) {
    state.analysesSynevoPerPage = items
  },
  ANALYSES_SYNEVO_SET_PER_PAGE_COUNT(state, count) {
    state.analysesSynevoPerPageCount = count
  },
  // Treatment features
  SET_TREATMENT_FEATURES_PER_PAGE(state, items) {
    state.treatmentFeaturesPerPage = items
  },
  SET_TREATMENT_FEATURES_PER_PAGE_COUNT(state, count) {
    state.treatmentFeaturesPerPageCount = count
  },
  TREATMENT_FEATURE_ADD(state, item) {
    state.treatmentFeaturesPerPage.push(item)
    state.treatmentFeaturesPerPageCount += 1
  },
  TREATMENT_FEATURE_EDIT(state, item) {
    const index = state.treatmentFeaturesPerPage.findIndex(element => element.id === item.id)
    Vue.set(state.treatmentFeaturesPerPage, index, item)
  },
  TREATMENT_FEATURE_DELETE(state, id) {
    const index = state.treatmentFeaturesPerPage.findIndex(item => item.id === id)
    state.treatmentFeaturesPerPage.splice(index, 1)
    state.treatmentFeaturesPerPageCount -= 1
  },
  SET_TREATMENT_FEATURES_FOR_DROPDOWN(state, items) {
    state.treatmentFeaturesForDropdown = items
  },
  // User service for time property
  SET_USER_SERVICE_FOR_TIME_PROPERTY_PER_PAGE(state, items) {
    state.userServiceForTimePropertyPerPage = items
  },
  SET_USER_SERVICE_FOR_TIME_PROPERTY_PER_PAGE_COUNT(state, count) {
    state.userServiceForTimePropertyPerPageCount = count
  },
  USER_SERVICE_FOR_TIME_PROPERTY_ADD(state, item) {
    state.userServiceForTimePropertyPerPage.push(item)
    state.userServiceForTimePropertyPerPageCount += 1
  },
  USER_SERVICE_FOR_TIME_PROPERTY_EDIT(state, item) {
    const index = state.userServiceForTimePropertyPerPage.findIndex(element => element.id === item.id)
    Vue.set(state.userServiceForTimePropertyPerPage, index, item)
  },
  USER_SERVICE_FOR_TIME_PROPERTY_DELETE(state, id) {
    const index = state.userServiceForTimePropertyPerPage.findIndex(item => item.id === id)
    state.userServiceForTimePropertyPerPage.splice(index, 1)
    state.userServiceForTimePropertyPerPageCount -= 1
  },
  // User dental service property
  SET_USER_DENTAL_SERVICE_PROPERTY_PER_PAGE(state, items) {
    state.userDentalServicePropertyPerPage = items
  },
  SET_USER_DENTAL_SERVICE_PROPERTY_PER_PAGE_COUNT(state, count) {
    state.userDentalServicePropertyPerPageCount = count
  },
  USER_DENTAL_SERVICE_PROPERTY_ADD(state, item) {
    state.userDentalServicePropertyPerPage.push(item)
    state.userDentalServicePropertyPerPageCount += 1
  },
  USER_DENTAL_SERVICE_PROPERTY_EDIT(state, item) {
    const index = state.userDentalServicePropertyPerPage.findIndex(element => element.id === item.id)
    Vue.set(state.userDentalServicePropertyPerPage, index, item)
  },
  USER_DENTAL_SERVICE_PROPERTY_DELETE(state, id) {
    const index = state.userDentalServicePropertyPerPage.findIndex(item => item.id === id)
    state.userDentalServicePropertyPerPage.splice(index, 1)
    state.userDentalServicePropertyPerPageCount -= 1
  },
  // User treatment plan property
  SET_USER_TREATMENT_PLAN_PROPERTY_PER_PAGE(state, items) {
    state.userTreatmentPlanPropertyPerPage = items
  },
  SET_USER_TREATMENT_PLAN_PROPERTY_PER_PAGE_COUNT(state, count) {
    state.userTreatmentPlanPropertyPerPageCount = count
  },
  USER_TREATMENT_PLAN_PROPERTY_ADD(state, item) {
    state.userTreatmentPlanPropertyPerPage.push(item)
    state.userTreatmentPlanPropertyPerPageCount += 1
  },
  USER_TREATMENT_PLAN_PROPERTY_EDIT(state, item) {
    const index = state.userTreatmentPlanPropertyPerPage.findIndex(element => element.id === item.id)
    Vue.set(state.userTreatmentPlanPropertyPerPage, index, item)
  },
  USER_TREATMENT_PLAN_PROPERTY_DELETE(state, id) {
    const index = state.userTreatmentPlanPropertyPerPage.findIndex(item => item.id === id)
    state.userTreatmentPlanPropertyPerPage.splice(index, 1)
    state.userTreatmentPlanPropertyPerPageCount -= 1
  },
  // User activity log items
  SET_USER_ACTIVITY_LOG_ITEMS_PER_PAGE(state, items) {
    state.userActivityLogItemsPerPage = items
  },
  SET_USER_ACTIVITY_LOG_ITEMS_PER_PAGE_COUNT(state, count) {
    state.userActivityLogItemsPerPageCount = count
  },
  // Pricing type groups
  SET_PRICING_TYPE_GROUPS(state, items) {
    state.pricingTypeGroups = items
  },
  ADD_PRICING_TYPE_GROUP(state, item) {
    state.pricingTypeGroups.push(item)
    state.pricingTypeGroups = state.pricingTypeGroups.sort((a, b) => a.name.localeCompare(b.name))
  },
  EDIT_PRICING_TYPE_GROUP(state, item) {
    const index = state.pricingTypeGroups.findIndex(group => group.id === item.id)
    Vue.set(state.pricingTypeGroups, index, item)
    state.pricingTypeGroups = state.pricingTypeGroups.sort((a, b) => a.name.localeCompare(b.name))
  },
  REMOVE_PRICING_TYPE_GROUP(state, id) {
    const index = state.pricingTypeGroups.findIndex(item => item.id === id)
    state.pricingTypeGroups.splice(index, 1)
  },
  SET_PRICING_TYPE_GROUP_ITEMS(state, items) {
    state.pricingTypeGroupItems = items
  },
  // Patient appointment status
  SET_PATIENT_APPOINTMENT_STATUS_PER_PAGE: (state, items) => state.patientAppointmentStatusesPerPage = items,
  SET_PATIENT_APPOINTMENT_STATUS_PER_PAGE_COUNT: (state, count) => state.patientAppointmentStatusesPerPageCount = count,
  SET_PATIENT_APPOINTMENT_STATUS: (state, items) => state.patientAppointmentStatuses = items,
  REMOVE_PATIENT_APPOINTMENT_STATUS(state, id) {
    const index = state.patientAppointmentStatusesPerPage.findIndex(item => item.id === id)
    state.patientAppointmentStatusesPerPage.splice(index, 1)
    state.patientAppointmentStatusesPerPageCount -= 1
  },
  EDIT_PATIENT_APPOINTMENT_STATUS(state, item) {
    const index = state.patientAppointmentStatusesPerPage.findIndex(pa => pa.id === item.id)
    Vue.set(state.patientAppointmentStatusesPerPage, index, item)
  },
  ADD_PATIENT_APPOINTMENT_STATUS(state, item) {
    state.patientAppointmentStatusesPerPage.push(item)
    state.patientAppointmentStatusesPerPageCount += 1
  },
  EDIT_PATIENT_APPOINTMENT_STATUS_IS_MAIN_ATTR(state, data) {
    state.patientAppointmentStatusesPerPage.map(app => app.is_main = data.id === app.id ? data.is_main : false)
  },
  EDIT_PATIENT_APPOINTMENT_STATUS_IS_MAIN_CONFIRMATION_LINK_ATTR(state, data) {
    state.patientAppointmentStatusesPerPage.map(
      app => app.is_main_confirmation_api = data.id === app.id ? data.is_main_confirmation_api : false
    )
  },
  EDIT_PATIENT_APPOINTMENT_STATUS_IS_MAIN_CANCEL_LINK_ATTR(state, data) {
    state.patientAppointmentStatusesPerPage.map(
      app => app.is_main_cancel_api = data.id === app.id ? data.is_main_cancel_api : false
    )
  },
  EDIT_PATIENT_APPOINTMENT_STATUS_IS_MAIN_MOVE_LINK_ATTR(state, data) {
    state.patientAppointmentStatusesPerPage.map(
      app => app.is_main_move_api = data.id === app.id ? data.is_main_move_api : false
    )
  },
  SET_PATIENT_APPOINTMENT_STATUS_SETTINGS: (state, data) => state.patientAppointmentStatusSettings = data,
  // FAQ
  SET_FAQ_QUESTIONS(state, items) {
    state.faqQuestions = items
  },
  ADD_FAQ_QUESTION(state, item) {
    state.faqQuestions.push(item)
    state.faqQuestions = state.faqQuestions.sort((a, b) => a.title.localeCompare(b.title))
  },
  EDIT_FAQ_QUESTION(state, item) {
    const index = state.faqQuestions.findIndex(pd => pd.id === item.id)
    Vue.set(state.faqQuestions, index, item)
  },
  FAQ_QUESTION_DELETE(state, id) {
    const index = state.faqQuestions.findIndex(item => item.id === id)
    state.faqQuestions.splice(index, 1)
  },
  // Medical service type
  SET_SERVICE_TYPES_FOR_DROPDOWN: (state, items) => state.serviceTypesForDropdown = items,
  SET_MEDICAL_SERVICE_TYPE_PER_PAGE: (state, items) => state.medicalServiceTypePerPage = items,
  SET_MEDICAL_SERVICE_TYPE_PER_PAGE_COUNT: (state, count) => state.medicalServiceTypePerPageCount = count,
  ADD_MEDICAL_SERVICE_TYPE(state, direction) {
    state.medicalServiceTypePerPage.push(direction)
    state.medicalServiceTypePerCount += 1
  },
  EDIT_MEDICAL_SERVICE_TYPE(state, item) {
    const index = state.medicalServiceTypePerPage.findIndex(d => d.id === item.id)
    Vue.set(state.medicalServiceTypePerPage, index, item)
  },
  REMOVE_MEDICAL_SERVICE_TYPE(state, itemId) {
    const index = state.medicalServiceTypePerPage.findIndex(direction => direction.id === itemId)
    state.medicalServiceTypePerPage.splice(index, 1)
    state.medicalServiceTypePerCount -= 1
  },
  // Specialist type
  SET_SPECIALIST_TYPES: (state, items) => state.specialistTypes = items,
  SET_SPECIALIST_TYPES_PER_PAGE: (state, items) => state.specialistTypesPerPage = items,
  SET_SPECIALIST_TYPES_PER_PAGE_COUNT: (state, count) => state.specialistTypesPerPageCount = count,
  ADD_SPECIALIST_TYPE(state, direction) {
    state.specialistTypesPerPage.push(direction)
    state.specialistTypesPerPageCount += 1
  },
  EDIT_SPECIALIST_TYPE(state, item) {
    const index = state.specialistTypesPerPage.findIndex(d => d.id === item.id)
    Vue.set(state.specialistTypesPerPage, index, item)
  },
  REMOVE_SPECIALIST_TYPE(state, itemId) {
    const index = state.specialistTypesPerPage.findIndex(direction => direction.id === itemId)
    state.specialistTypesPerPage.splice(index, 1)
    state.specialistTypesPerPageCount -= 1
  },
  EDIT_SPECIALIST_TYPE_HIDDEN_ATTR(state, data) {
    state.specialistTypesPerPage.map(st => st.hidden = data.id === st.id ? data.hidden : false)
  },
  // Dental service specialist type property
  SET_DENTAL_SERVICE_SPECIALIST_TYPE_PROPERTY_PER_PAGE(state, items) {
    state.dentalServiceSpecialistTypePerPage = items
  },
  SET_DENTAL_SERVICE_SPECIALIST_TYPE_PROPERTY_PER_PAGE_COUNT(state, count) {
    state.dentalServiceSpecialistTypePerPageCount = count
  },
  DENTAL_SERVICE_SPECIALIST_TYPE_PROPERTY_ADD(state, item) {
    state.dentalServiceSpecialistTypePerPage.push(item)
    state.dentalServiceSpecialistTypePerPageCount += 1
  },
  DENTAL_SERVICE_SPECIALIST_TYPE_PROPERTY_EDIT(state, item) {
    const index = state.dentalServiceSpecialistTypePerPage.findIndex(element => element.id === item.id)
    Vue.set(state.dentalServiceSpecialistTypePerPage, index, item)
  },
  DENTAL_SERVICE_SPECIALIST_TYPE_PROPERTY_DELETE(state, id) {
    const index = state.dentalServiceSpecialistTypePerPage.findIndex(item => item.id === id)
    state.dentalServiceSpecialistTypePerPage.splice(index, 1)
    state.dentalServiceSpecialistTypePerPageCount -= 1
  },
  // Material price list
  UPDATE_MATERIAL_PRICE_LIST(state, item) {
    const index = state.materialPriceList.findIndex(priceList => priceList.id === -1 || priceList.id === item.id)
    if (index > -1) {
      state.materialPriceList[index] = item
    }
  },
  SET_MATERIAL_PRICE_LIST(state, items) {
    state.materialPriceList = items
  },
  DELETE_MATERIAL_PRICE_LIST(state, id) {
    const index = state.materialPriceList.findIndex(item => item.id === id)
    state.materialPriceList.splice(index, 1)
  },
  SET_MATERIAL_PRICE_LIST_ITEMS(state, items) {
    state.materialPriceListItems = items
  },
  SET_MATERIAL_PRICE_LIST_ITEMS_COUNT(state, count) {
    state.materialPriceListItemsCount = count
  },
  UPDATE_MATERIAL_PRICE_LIST_ITEM(state, item) {
    const index = state.materialPriceListItems.findIndex(priceListItem => priceListItem.id === item.id)
    if (index > -1) {
      Vue.set(state.materialPriceListItems, index, item)
    }
  },
  // Branch
  // SET_SPECIALIST_TYPES: (state, items) => state.specialistTypes = items,
  SET_INTEGRATOR_BRANCHES_PER_PAGE: (state, items) => state.integratorBranchesPerPage = items,
  SET_INTEGRATOR_BRANCHES_PER_PAGE_COUNT: (state, count) => state.integratorBranchesPerPageCount = count,
  ADD_INTEGRATOR_BRANCH(state, direction) {
    state.integratorBranchesPerPage.push(direction)
    state.integratorBranchesPerPage = state.integratorBranchesPerPage.sort(
      (a, b) => a.name.toLowerCase() > b.name.toLowerCase()
        ? 1 : (b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 0)
    )
    state.integratorBranchesPerPageCount += 1
  },
  INTEGRATOR_BRANCH_CHANGE_ENABLE_STATE(state, data) {
    const idx = state.integratorBranchesPerPage.findIndex(item => item.id === data.id)
    state.integratorBranchesPerPage[idx].enabled = data.enabled
  },
  EDIT_INTEGRATOR_BRANCH(state, item) {
    const index = state.integratorBranchesPerPage.findIndex(d => d.id === item.id)
    Vue.set(state.integratorBranchesPerPage, index, item)
    state.integratorBranchesPerPage = state.integratorBranchesPerPage.sort(
      (a, b) => a.name.toLowerCase() > b.name.toLowerCase()
        ? 1 : (b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 0)
    )
  },
  REMOVE_INTEGRATOR_BRANCH(state, itemId) {
    const index = state.integratorBranchesPerPage.findIndex(direction => direction.id === itemId)
    state.integratorBranchesPerPage.splice(index, 1)
    state.integratorBranchesPerPageCount -= 1
  },
  BRANCH_LOGIC_ENABLE(state, id) {
    const idx = state.integrators.findIndex(item => item.id === id)
    state.integrators[idx].branch_enabled = true
  },
  BRANCH_LOGIC_DISABLE(state, id) {
    const idx = state.integrators.findIndex(item => item.id === id)
    state.integrators[idx].branch_enabled = false
  },
  // Integrator settings
  SET_INTEGRATOR_SETTINGS(state, settings) {
    state.integratorSettings = settings
  },
  // Third party organization
  SET_THIRD_PARTY_ORGANIZATIONS_FOR_DROPDOWN: (state, items) => state.thirdPartyOrganizationsForDropdown = items,
  SET_THIRD_PARTY_ORGANIZATIONS: (state, items) => state.thirdPartyOrganizations = items,
  SET_THIRD_PARTY_ORGANIZATIONS_COUNT: (state, count) => state.thirdPartyOrganizationsCount = count,
  THIRD_PARTY_ORGANIZATION_ADD(state, item) {
    state.thirdPartyOrganizations.push(item)
    state.thirdPartyOrganizationsCount += 1
  },
  THIRD_PARTY_ORGANIZATION_EDIT(state, item) {
    const index = state.thirdPartyOrganizations.findIndex(element => element.id === item.id)
    Vue.set(state.thirdPartyOrganizations, index, item)
  },
  THIRD_PARTY_ORGANIZATION_DELETE(state, id) {
    const index = state.thirdPartyOrganizations.findIndex(item => item.id === id)
    state.thirdPartyOrganizations.splice(index, 1)
    state.thirdPartyOrganizationsCount -= 1
  },
  // Recommended visit type
  SET_RECOMMENDED_VISIT_TYPES_FOR_DROPDOWN: (state, items) => state.recommendedVisitTypesForDropdown = items,
  SET_RECOMMENDED_VISIT_TYPES: (state, items) => state.recommendedVisitTypes = items,
  SET_RECOMMENDED_VISIT_TYPES_COUNT: (state, count) => state.recommendedVisitTypesCount = count,
  RECOMMENDED_VISIT_TYPE_ADD(state, item) {
    state.recommendedVisitTypes.push(item)
    state.recommendedVisitTypesCount += 1
  },
  RECOMMENDED_VISIT_TYPE_EDIT(state, item) {
    const index = state.recommendedVisitTypes.findIndex(element => element.id === item.id)
    Vue.set(state.recommendedVisitTypes, index, item)
  },
  RECOMMENDED_VISIT_TYPE_DELETE(state, id) {
    const index = state.recommendedVisitTypes.findIndex(item => item.id === id)
    state.recommendedVisitTypes.splice(index, 1)
    state.recommendedVisitTypesCount -= 1
  },
  // Specialist type wage deductions amount
  SET_SPECIALIST_TYPE_WAGE_DEDUCTIONS_AMOUNT_PER_PAGE: (state, items) =>
    state.specialistTypeWageDeductionsAmountPerPage = items,
  SET_SPECIALIST_TYPE_WAGE_DEDUCTIONS_AMOUNT_PER_PAGE_COUNT: (state, count) =>
    state.specialistTypeWageDeductionsAmountPerPageCount = count,
  SPECIALIST_TYPE_WAGE_DEDUCTION_AMOUNT_ADD(state, i) {
    state.specialistTypeWageDeductionsAmountPerPage.push(i)
    state.specialistTypeWageDeductionsAmountPerPageCount += 1
  },
  SPECIALIST_TYPE_WAGE_DEDUCTION_AMOUNT_EDIT(state, i) {
    const index = state.specialistTypeWageDeductionsAmountPerPage.findIndex(e => e.id === i.id)
    Vue.set(state.specialistTypeWageDeductionsAmountPerPage, index, i)
  },
  SPECIALIST_TYPE_WAGE_DEDUCTION_AMOUNT_DELETE(state, id) {
    const index = state.specialistTypeWageDeductionsAmountPerPage.findIndex(item => item.id === id)
    state.specialistTypeWageDeductionsAmountPerPage.splice(index, 1)
    state.specialistTypeWageDeductionsAmountPerPageCount -= 1
  },
  // Counterparties
  SET_COUNTERPARTIES(state, items) {
    state.counterparties = items
  },
  SET_COUNTERPARTIES_COUNT(state, count) {
    state.counterpartiesCount = count
  },
  COUNTERPARTY_ADD(state, item) {
    state.counterparties.push(item)
    state.counterpartiesCount += 1
  },
  COUNTERPARTY_EDIT(state, item) {
    const index = state.counterparties.findIndex(element => element.id === item.id)
    Vue.set(state.counterparties, index, item)
  },
  COUNTERPARTY_DELETE(state, id) {
    const index = state.counterparties.findIndex(i => i.id === id)
    state.counterparties.splice(index, 1)
    state.counterpartiesCount -= 1
  },
  // Tooth state
  SET_TEETH_STATES: (state, items) => state.teethStates = items,
  SET_TEETH_STATES_COUNT: (state, count) => state.teethStatesCount = count,
  TOOTH_STATE_ADD(state, item) {
    state.teethStates.push(item)
    state.teethStatesCount += 1
  },
  TOOTH_STATE_EDIT(state, item) {
    const index = state.teethStates.findIndex(element => element.id === item.id)
    Vue.set(state.teethStates, index, item)
  },
  TOOTH_STATE_DELETE(state, id) {
    const index = state.teethStates.findIndex(item => item.id === id)
    state.teethStates.splice(index, 1)
    state.teethStatesCount -= 1
  },
  // Tooth state services
  SET_TOOTH_STATE_SERVICES_PER_PAGE: (state, items) => state.toothStateServicesPerPage = items,
  SET_TOOTH_STATE_SERVICES_PER_PAGE_COUNT: (state, count) => state.toothStateServicesPerPageCount = count,
  // Tooth state complexes
  SET_TOOTH_STATE_COMPLEXES_PER_PAGE: (state, items) => state.toothStateComplexesPerPage = items,
  SET_TOOTH_STATE_COMPLEXES_PER_PAGE_COUNT: (state, count) => state.toothStateComplexesPerPageCount = count,
}
